<header class="app-header">
  <ui5-shellbar primary-title="ITU User Management" (logoClick)="handleLogoClick()" >
    <ui5-button class="hamburger-icon" icon="menu" slot="startButton" (click)="handleHamburgerClick()"></ui5-button>
    <img src="./assets/images/itu_logo_HighRes.png" slot="logo" />    
    <ui5-text slot="profile" class="header-user-name">{{ memberOrganizationInfo.name }} {{ memberOrganizationInfo.lastname }} </ui5-text>
    <ui5-shellbar-item icon="log" text="Sign out"  (click)="handleSignOut()" class="right-element">Sign out</ui5-shellbar-item>
  </ui5-shellbar>

  <div *ngIf="memberOrganizationInfo.orgName">
    <ui5-title class="title">{{ memberOrganizationInfo.orgName }}</ui5-title>
  </div>

</header>



